import { Capacitor } from '@capacitor/core';

const fallbackApiBaseUrl = () => {
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl && !envUrl.includes('localhost') && !envUrl.includes('127.0.0.1')) return envUrl;
  if (Capacitor.isNativePlatform()) {
    return 'https://yukortagim.doguscay.com.tr/api';
  }
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '/api';
  }
  return envUrl || 'https://yukortagim.doguscay.com.tr/api';
};

// API Configuration
export const API_CONFIG = {
  // Toggle between mock (localStorage) and real API
  USE_MOCK_API: false, // Set to false to use real backend API
  
  // Backend API URL
  BASE_URL: fallbackApiBaseUrl(),

  // Request timeout
  TIMEOUT: 30000,
};

// Auth token management
export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('authToken');
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
